module.exports = __webpack_public_path__ + "static/media/loadmore-wheel.2f7111f2.svg";